/**
 * Menu per l'inserimento dei placeholder dinamici nel corpo (§11.5).
 * Inserisce il token come testo nella posizione corrente del cursore.
 *
 * `extraItems`: blocchi aggiuntivi (HTML) offerti in fondo al menu, es. lo spazio
 * contenuto e la disiscrizione nell'editor dei template.
 */
import { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Divider, Menu, MenuItem, ListItemText } from '@mui/material';
import DataObjectIcon from '@mui/icons-material/DataObject';
import { PLACEHOLDERS } from '../../../../../utils/newsletter/emailHtml';

/**
 * @param {{
 *   editor: import('@tiptap/react').Editor|null,
 *   disabled?: boolean,
 *   extraItems?: Array<{ label: string, secondary?: string, content: string }>,
 * }} props
 */
export function PlaceholderMenu({ editor, disabled, extraItems = [] }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  if (!editor) return null;

  const handleInsert = (content) => {
    editor.chain().focus().insertContent(content).run();
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        size="small"
        startIcon={<DataObjectIcon fontSize="small" />}
        disabled={disabled}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{ color: '#212b36', textTransform: 'none' }}
      >
        Inserisci campo
      </Button>

      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        {PLACEHOLDERS.map((p) => (
          <MenuItem key={p.token} onClick={() => handleInsert(p.token)}>
            <ListItemText primary={p.label} secondary={p.token} />
          </MenuItem>
        ))}
        {extraItems.length > 0 && <Divider />}
        {extraItems.map((item) => (
          <MenuItem key={item.label} onClick={() => handleInsert(item.content)}>
            <ListItemText primary={item.label} secondary={item.secondary} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

PlaceholderMenu.propTypes = {
  editor: PropTypes.object,
  disabled: PropTypes.bool,
  extraItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      secondary: PropTypes.string,
      content: PropTypes.string.isRequired,
    })
  ),
};

export default PlaceholderMenu;
